import { createTheme, adaptV4Theme } from "@mui/material/styles";

const theme = createTheme(adaptV4Theme({
  palette: {
	theme: "dark",
    main: "#2e9fda",
    primary: {
      main: "#2e9fda",
  	  contrastText: "#ffffff",
    },
    secondary: {
      main: "rgba(255,255,255,0.7)",
	  contrastText: "#000000",
    },
    text: {
      secondary: "rgba(0,0,0,0.8)",
    },
    type: "dark",
    //inputColor: "#FFFFFF",
    
	inputColor: "rgba(0, 0, 0, 1)",
    surfaceColor: "#ffffffff",
    //platformColor: "#FFFFFF",
    platformColor: "#FFFFFF",
    backgroundColor: "#FFFFFF",
	distributionColor: "#40E0D0",

    green: "#5cc879",
    borderRadius: 8,
    defaultBorder: "1px solid rgba(255,255,255,0.3)",

	//jsonTheme: "brewer",
	//jsonTheme: "chalk",
	//jsonTheme: "monokai",
	//jsonTheme: "google",
	//jsonTheme: "tomorrow",
	jsonIconStyle: "round",
	jsonTheme: "summerfruit",
	jsonCollapseStringsAfterLength: 100,

	reactJsonStyle: {
		padding: 5, 
		width: "98%",
		borderRadius: 5,
		border: "1px solid rgba(255,255,255,0.7)",
		overflowX: "auto",
	},
    textFieldStyle: {
      backgroundColor: "#FFFFFF",
      borderRadius: 5,
	  height: 40, 
    },
    DialogStyle: {
      backgroundColor: "#FFFFFF",
      borderRadius: 2,
      boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
      border: "1px solid #494949",
    },
    innerTextfieldStyle: {
	  height: 40,
	  fontSize: 16,
      backgroundColor: "#FFFFFF",
	  // Removed since upgrading to mui 18
      //color: "black",
      //minHeight: 50,
      //marginLeft: "5px",
      //maxWidth: "95%",
      //fontSize: "1em",
      //borderRadius: 5,
    },
    tooltip: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: 1,
      fontSize: 11,
    },
    defaultImage: "/images/no_image.png",
	singulOrange: "/images/singul_orange.png",
	singulGreen: "/images/singul_green.png",
	singulBlackWhite: "/images/singul_black_white.png",
  },
  typography: {
    fontFamily: `"inter", "Roboto", "Helvetica", "Arial", sans-serif`,
    useNextVariants: true,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    h1: {
      fontSize: 40,
    },
    h4: {
      fontSize: 30,
      fontWeight: 500,
    },
    h6: {
      fontSize: 22,
    },
    body1: {
      fontSize: 18,
    },
  },
  overrides: {
    MuiMenu: {
      list: {
        backgroundColor: "#FFFFFF",
      },
    },
    MuiCssBaseline: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'Inter';
            font-style: normal;
            font-display: swap;
            font-weight: 300;
            src: local('Inter Light'), local('Inter-Light');
          }
          @font-face {
            font-family: 'Inter';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('Inter Regular'), local('Inter-Regular');
          }
          @font-face {
            font-family: 'Inter';
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: local('Inter Medium'), local('Inter-Medium');
          }
          @font-face {
            font-family: 'Inter';
            font-style: normal;
            font-display: swap;
            font-weight: 600;
            src: local('Inter SemiBold'), local('Inter-SemiBold');
          }
          @font-face {
            font-family: 'Inter';
            font-style: normal;
            font-display: swap;
            font-weight: 700;
            src: local('Inter Bold'), local('Inter-Bold');
          }
        `,
      },
	},
  },
}));

export default theme;

export const getTheme = (themeMode, brandColor) =>
  createTheme({
      palette: {
        mode: themeMode,
        main: brandColor || "#2e9fda",
        primary: {
          main: brandColor || "#2e9fda",
          contrastText:  "#000000ff",
        },
        secondary: {
          main: "rgba(0, 0, 0, 0.7)",
          contrastText:"#000000",
        },
        text: {
          primary: themeMode === "dark" ? "#000000ff" : "#000000ff",
          secondary: themeMode === "dark" ? "#000000ff" : "#000000ff",
        },
        type: themeMode,
        inputColor: themeMode === "dark" ? "rgba(0, 0, 0, 1)" : "rgba(0, 0, 0, 1)",
        textColor: themeMode === "dark" ? "#000000" : "#000000",
        textPrimary: themeMode === "dark" ? "rgba(0, 0, 0, 0.8)" : "rgba(26, 26, 26, 0.8)",
        surfaceColor: themeMode === "dark" ? "#27292d" : "#EFEFEF",
        platformColor: themeMode === "dark" ? "#FFFFFF" : "#ffffff",
        backgroundColor: themeMode === "dark" ? "#FFFFFF" : "#FFFFFF",
        distributionColor: themeMode === "dark" ? "#40E0D0" : "#008080",
        cardBackgroundColor: themeMode === "dark" ? "#ffffffff" : "#eaeaea",
        cardHoverColor: themeMode === "dark" ? "#323232" : "#F0F0F0", 
        hoverColor: themeMode === "dark" ? "#323232" : "#D6D6D6",
        usecaseCardColor: themeMode === "dark" ? "#FFFFFF" : "rgba(245, 245, 245, 1)",
        usecaseCardHoverColor: themeMode === "dark" ? "#FFFFFF" : "rgba(245, 245, 245, 1)",
        usecaseDialogFieldColor: themeMode === "dark" ? "#2B2B2B" : "#F5F5F5",
        accentColor: themeMode === "dark" ? "#5a66af" : "#5a66af",
        green: themeMode === "dark" ? "#5cc879" : "#008000",
        defaultBorder: themeMode === "dark" ? '1px solid #494949' : '1px solid #CCCCCC',
        linkColor: brandColor === "#5a66af" ? "#2e9fda" : brandColor,

        borderRadius: 10,
        loaderColor: themeMode === "dark" ? "#FFFFFF" : "#E0E0E0",
        jsonIconStyle: "round",
        jsonTheme: themeMode === "dark" ? "summerfruit" : {
          base00: "#ffffff", // background
          base01: "#f0f0f0", // very light grey
          base02: "#f5f5f5", // light grey
          base03: "#999999", // dim text
          base04: "#444444", // bold keys
          base05: "#333333", // normal text
          base06: "#FFFFFF", // darker text
          base07: "#000000", // black
          base08: "#5a66af", // red
          base09: "#2e9fda", // blue
          base0A: "#f2c032", // yellow
          base0B: "#51975d", // green
          base0C: "#2aa198", // teal
          base0D: "#007acc", // blue (keys!)
          base0E: "#c586c0", // purple
          base0F: "#458dca", // brown
        },
        jsonCollapseStringsAfterLength: 100,
        drawer: {
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffffff"
        },
        reactJsonStyle: {
          padding: 5,
          width: "98%",
          borderRadius: 5,
          border: themeMode === "dark" ? "1px solid rgba(255,255,255,0.7)" : "1px solid rgba(0,0,0,0.3)",
          backgroundColor: themeMode === "dark"
            ? "#FFFFFF"
            : "#FFFFFF",
          color: themeMode === "dark"
            ? "#000000"
            : "#000000",
          overflowX: "auto",
        },        
        textFieldStyle: {
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#FFFFFF",
          color: themeMode === "dark" ? "#000000ff" : "#000000",
          borderRadius: "5px",
          height: 40,
          border: themeMode === "dark" ? "1px solid #4D4D4D" : "1px solid #E0E0E0",
        },
        DialogStyle: {
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffff",
          borderRadius: 2,
          boxShadow: themeMode === "dark" ? "0px 0px 10px 0px rgba(0,0,0,0.75)" : "0px 0px 10px 0px rgba(0,0,0,0.2)",
          border: themeMode === "dark" ? "1px solid #494949" : "1px solid #cccccc",
        },
        innerTextfieldStyle: {
          height: 40,
          fontSize: 16,
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffffff",
        },
        tooltip: {
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffff",
          color: themeMode === "dark" ? "#000000ff" : "#000000",
          border: themeMode === "dark" ? "1px solid #494949" : "1px solid #cccccc",
        },
        chipStyle: {
          backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffffff",
          borderColor: themeMode === "dark" ? "#444444" : "#E0E0E0",
          //color: themeMode === "dark" ? "#FFFFFF" : "#333333",
          color: "#FFFFFF",
        },        
        defaultImage: "/images/no_image.png",
        singulOrange: "/images/singul_orange.png",
        singulGreen: "/images/singul_green.png",
        singulBlackWhite: "/images/singul_black_white.png",
        scrollbarColor: themeMode === "dark" ? "#494949 #FFFFFF": "#c1c1c1 #FFFFFF",
        scrollbarColorTransparent: themeMode === "dark" ? '#494949 transparent': "#c1c1c1 transparent",
      },
      typography: {
        fontFamily: `"inter", "Roboto", "Helvetica", "Arial", sans-serif`,
        color: themeMode === "dark" ? "#000000ff" : "#000000",
        useNextVariants: true,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemiBold: 600,
        fontWeightBold: 700,
        allVariants: {
          color: themeMode === "dark" ? "#000000ff" : "#000000ff",
        },      
        h1: {
          fontSize: 40,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        h2: {
          fontSize: 36,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        h3: {
          fontSize: 32,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        h4: {
          fontSize: 30,
          fontWeight: 500,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        h6: {
          fontSize: 22,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        body1: {
          fontSize: 16,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
        body2: {
          fontSize: 14,
          color: themeMode === "dark" ? "#000000ff" : "#000000ff"
        },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none',
              borderRadius: '4px',
            },
          },
          variants: [
            {
              props: { variant: 'text', color: 'primary' },
              style: {
                color: themeMode === "dark" ? "#000000ff" : "#000000ff",
                whiteSpace: "nowrap",
		            textWrap: "normal",
              },
            },
            {
              props: { variant: 'text', color: 'secondary' },
              style: {
                color: themeMode === "dark" ? "#000000ff" : "#000000ff",
                whiteSpace: "nowrap",
		            textWrap: "normal",
              },
            },
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                backgroundColor: themeMode === "dark" ? brandColor || '#5a66af' : brandColor || '#2e9fda',
                color: themeMode === "dark" ? '#000000ff': '#000000ff',
                borderRadius: '4px',
                whiteSpace: "nowrap",
		            textWrap: "normal",
                '&:hover': {
                  fontWeight: 600,
                  backgroundColor: themeMode === 'dark' ? brandColor || "#2e9fda" : brandColor || '#2e9fda',
                  color: themeMode === "dark" ? '#FFFFFF': '#FFFFFF',
                },
              },
            },
            {
              props: { variant: 'contained', color: 'secondary' },
              style: {
                backgroundColor: themeMode === "dark" ? '#ffffffff' : '#ffffffff',
                color: themeMode === "dark" ? '#000000ff' : '#000000ff',
                borderRadius: '4px',
                boxShadow: 'none',
                whiteSpace: "nowrap",
		            textWrap: "normal",
                '&:hover': {
                  fontWeight: 600,
                  border: themeMode === "dark" ? '1px solid #000000ff' : 'none',
                  backgroundColor: themeMode === "dark" ? '#ffffffff' : '#ffffffff',
                  color: themeMode === "dark" ? '#000000ff' : '#000000ff',
                },
              },
            },
            {
              props: { variant: 'outlined', color: 'primary' },
              style: {
                borderColor: themeMode === "dark" ?  brandColor || "#5a66af" : brandColor || "#2e9fda",
                color: themeMode === "dark" ? brandColor || "#5a66af" : brandColor || "#2e9fda",
                whiteSpace: "nowrap",
                fontWeight: 'normal',
		            textWrap: "normal",
                '&:hover': {
                  backgroundColor: themeMode === "dark" ? brandColor || "#5a66af" : "#ffe8dc",
                  color: themeMode === "dark" ? "#000000ff" : "#000000ff",
                  fontWeight: 600,
                },
              },
            },            
            {
              props: { variant: 'outlined', color: 'secondary' },
              style: {
                border: '1px solid #282828ff',
                color: themeMode === "dark" ? '#000000ff' : '#000000ff',
                whiteSpace: "nowrap",
		            textWrap: "normal",
                '&:hover': {
                  backgroundColor: themeMode === "dark" ? '#ffffffff' : '#ffffffff',
                  borderColor: themeMode === "dark" ? '#1b1b1bff' : '#2D2D2D',
                  fontWeight: 600,
                  color: themeMode === "dark" ? '#000000ff' : '#040404ff',
                },
              },
            },
            {
              props: { variant: 'aiButton' },
              style: {
                background: 'linear-gradient(90deg, #5a66af 0%, #ffffffff 50%, #9c5af2 100%)',
                color: '#000000',
                borderRadius: '4px',
                whiteSpace: "nowrap",
                textWrap: "normal",
                border: 'none',
                boxShadow: 'none',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  color: '#000000',
                  textShadow: '0 0 1px currentColor',
                },
                '&:active': {
                  background: 'linear-gradient(90deg, #2e9fda 0%, #31b4ec 50%, #8a4de8 100%)',
                },
                '&:disabled': {
                  background: themeMode === "dark" ? '#ffffffff' : '#ffffffff',
                  color: themeMode === "dark" ? '#000000ff' : '#000000ff',
                },
              },
            },
            {
              props: { variant: 'aiButtonGhost' },
              style: {
                background: 'transparent',
                border: 'none',
                borderRadius: '4px',
                color: '#000000',
                whiteSpace: "nowrap",
                textWrap: "normal",
                boxShadow: 'none',
                transition: 'all 0.2s ease-in-out',
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: '4px',
                  padding: '2px',
                  background: 'linear-gradient(90deg, #5a66af 0%, #51a6ecff 50%, #9c5af2 100%)',
                  mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  maskComposite: 'exclude',
                  WebkitMaskComposite: 'xor',
                  transition: 'opacity 0.2s ease-in-out',
                  zIndex: -1,
                },
                '&:hover': {
                  background: 'linear-gradient(90deg, #5a66af 0%, #519eecff 50%, #9c5af2 100%)',
                  color: '#000000',
                  '&::before': {
                    opacity: 0,
                  },
                },
                '&:active': {
                  background: 'linear-gradient(90deg, #2e9fda 0%, #4579d4ff 50%, #8a4de8 100%)',
                },
                '&:disabled': {
                  background: 'transparent',
                  color: themeMode === "dark" ? '#000000ff' : '#000000ff',
                  '&::before': {
                    background: themeMode === "dark" ? '#ffffffff' : '#ffffffff',
                  },
                },
              },
            },
          ],
        },
        MuiTab: {
          styleOverrides: {
            root: {
              color: themeMode === "dark" ? "#000000ff" : "#000000ff",
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: themeMode === "dark" ? "#ffffff" : "#ffffff",
            color: themeMode === "dark" ? "#000000" : "#000000",
            boxShadow: "none",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: themeMode === "dark" ? "#ffffff" : "#ffffff",
            color: themeMode === "dark" ? "#000000" : "#000000",
          },
        },
      },

      overrides: {
        MuiMenu: {
          list: {
            backgroundColor: themeMode === "dark" ? "#ffffffff" : "#ffffff",
          },
        },
        MuiCssBaseline: {
          MuiCssBaseline: {
            styleOverrides: `
              @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-display: swap;
                font-weight: 300;
                src: local('Inter Light'), local('Inter-Light');
              }
              @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-display: swap;
                font-weight: 400;
                src: local('Inter Regular'), local('Inter-Regular');
              }
              @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-display: swap;
                font-weight: 500;
                src: local('Inter Medium'), local('Inter-Medium');
              }
              @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-display: swap;
                font-weight: 600;
                src: local('Inter SemiBold'), local('Inter-SemiBold');
              }
              @font-face {
                font-family: 'Inter';
                font-style: normal;
                font-display: swap;
                font-weight: 700;
                src: local('Inter Bold'), local('Inter-Bold');
              }
            `,
          },
        },
      },
    });
